import { useT } from "@/i18n/I18nProvider";
import { SEO } from "@/components/common/SEO";
import { PageHero } from "@/components/common/PageHero";
import { IndexCardList } from "@/components/common/IndexCardList";
import { ContactCta } from "@/components/common/DetailPage";
import type { RouteKey } from "@/lib/routes";

interface IndexPageProps {
  routeKey: RouteKey;
  items: RouteKey[];
  imageMap?: Partial<Record<RouteKey, string>>;
  heroImageUrl?: string;
}

/**
 * Shared index page for Services / Commodities / Compliance / Resources.
 */
export default function IndexPage({ routeKey, items, imageMap, heroImageUrl }: IndexPageProps) {
  const { t } = useT();

  return (
    <>
      <SEO routeKey={routeKey} />
      <PageHero routeKey={routeKey} imageUrl={heroImageUrl} imageAlt={t.routes[routeKey].title} />

      <section className="container-bnm py-16 md:py-24">
        <IndexCardList items={items} imageMap={imageMap} testIdPrefix={`idx-${routeKey.replace(".", "-")}`} />
      </section>

      <ContactCta />
    </>
  );
}
